<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "texts",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "text",
      fields: [
              {
            col:' col-12 col-md-12',
            key: "key",
            label: "Ключ",
            type: "field",
            textType: "text",
      },
      {
          col:' col-12 col-md-12',
          key: "group",
          label: "Группа",
          type: "static_radio",
          items: [
              { id: 'button', title: "Кнопки" },
              { id: 'label', title: "Заголовки" },
              { id: 'placeholder', title: "Заполнитель" },
                       { id: 'info', title: "Ифно" },
          ],
      },
      {
        label: "Название",
        key: "title",
        type: "field",
        textType: "text", 
        isMultiLang:true
    },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_text",
      itemLink: "texts",
      setLink: "texts",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "key",
          title: "Ключ",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
        {
          key: "group",
          title: "Группа",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
    
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
